// Not ported (dead in the Angular app): saveItem, deleteItem, getClientOverrides, saveClientOverride,
// deleteClientOverride, getUpgrades, getEffectivePack, pinEffectivePack
import { api } from '@/core/http/apiClient';
import type {
  CompareUpgradePayload,
  CreatePracticePackPayload,
  GoldenFixtureRow,
  GoldenRunResult,
  PackLayerRow,
  PackPreviewRow,
  PackUpgradeDetail,
  PracticePackRow,
  PublishPracticePackPayload,
  PublishPracticePackResponse,
  ResolvePackConflictsPayload,
} from '@/core/models/phase7.models';

const base = 'PracticePacks';

interface LayerOptions {
  clientId?: string | null;
  itemType?: string | null;
  search?: string | null;
}

// The query string stays in the path (encodeURIComponent, like Angular) rather than in `params`.
function layerQuery(options: LayerOptions): string {
  const parts: string[] = [];
  if (options.clientId) {
    parts.push(`clientId=${encodeURIComponent(options.clientId)}`);
  }
  if (options.itemType) {
    parts.push(`itemType=${encodeURIComponent(options.itemType)}`);
  }
  if (options.search) {
    parts.push(`search=${encodeURIComponent(options.search)}`);
  }
  return parts.length > 0 ? `?${parts.join('&')}` : '';
}

export const practicePackService = {
  getPacks: (frameworkCode?: string | null) => {
    const query = frameworkCode ? `?frameworkCode=${encodeURIComponent(frameworkCode)}` : '';
    return api.get<PracticePackRow[]>(`${base}/getPacks${query}`);
  },

  createPack: (payload: CreatePracticePackPayload) => api.post<PracticePackRow>(`${base}/createPack`, payload),

  getLayers: (practicePackId: string, options: LayerOptions = {}) =>
    api.get<PackLayerRow[]>(`${base}/getLayers/${practicePackId}${layerQuery(options)}`),

  compareUpgrade: (payload: CompareUpgradePayload) => api.post<PackUpgradeDetail>(`${base}/compareUpgrade`, payload),

  getUpgrade: (packUpgradeId: string) => api.get<PackUpgradeDetail>(`${base}/getUpgrade/${packUpgradeId}`),

  resolveConflicts: (payload: ResolvePackConflictsPayload) =>
    api.post<PackUpgradeDetail>(`${base}/resolveConflicts`, payload),

  getPreview: (packUpgradeId: string) => api.get<PackPreviewRow[]>(`${base}/getPreview/${packUpgradeId}`),

  getFixtures: () => api.get<GoldenFixtureRow[]>(`${base}/getFixtures`),

  runRegression: (packUpgradeId: string) => api.post<GoldenRunResult>(`${base}/runRegression/${packUpgradeId}`, {}),

  publishPack: (payload: PublishPracticePackPayload) =>
    api.post<PublishPracticePackResponse>(`${base}/publishPack`, payload),
};
